<div class="strategic-partnership-container">
  <div class="strategic-partnership-section">
    <div class="strategic-partnership-card">
      <div class="header">
        <h3>{{ vendorProfile.partnershipPrograms }}</h3>
        <div class="filter">
          <emerald-dropdown
            [options]="quarterOptions"
            [outlined]="true"
            [id]="'single_select'"
            [label]="'Quarter'"
            (onChange)="onFilterChange($event)"
          ></emerald-dropdown>
        </div>
      </div>
      <div class="items-container">
        <div class="item" *ngFor="let item of strategicPartnershipDisplayData">
          <div class="strategic-row">
            <div class="strategic-block">
              <div class="label-row">
                <span class="label">{{ item.label }}</span>
                <a  [href]="item.fileUrl" download>
                  <img
                    class="logo"
                    src="../../../../../assets/icons/excel.svg"
                    alt="Download {{ item.label }}"
                  />
                </a>
              </div>
              <span class="value">{{ item.value }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="spacer"></div>
  </div>
</div>
